import { hysteriFetch, wrappers } from 'hysterics';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';

const inventoryClientService = hysteriFetch('inventoryClientService', {
	timeout: {
		timeout: 1900
	},
	[wrappers.retry.contextKey]: {
		retries: 1
	}
});

let initialLoad = true;

export default async function fetchInventory({
	searchTerm,
	siteId,
	locale = 'en_US',
	widgetSearchServiceUri = '',
	configTypes,
	resultsPageAlias = ''
}) {
	const response = await inventoryClientService(
		`${widgetSearchServiceUri}/inventorySearch/${siteId}/${locale}?q=${encodeURIComponent(
			searchTerm
		)}
		&ct=${configTypes}`
	);

	// TODO: Temporary code.
	// There are instances where a user gets navigated to the catch-all search results page
	// rather than the SRP as a result of typing too fast and hitting return.

	// Logging to NR when the following conditions are met:
	// When the user is redirected to the search results page
	// AND only once on initial load
	// AND when the document.referrer happens to be the same domain
	if (
		window.location.href.includes(resultsPageAlias) &&
		initialLoad &&
		document.referrer.startsWith(window.location.origin)
	) {
		const suggestions = (response && response.suggestions) || [];
		const { count } = suggestions[0] || 0;
		if (count > 0) {
			setNewRelicCustomAttribute(
				'wsSiteTextSearch-navigatedToSearchPageByError',
				'true'
			);
		}
		initialLoad = false;
	}

	return response;
}
